import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import Button from '@material-ui/core/Button';

const useStyles = makeStyles((theme) => ({
    button: {
        display: 'block',
        marginTop: theme.spacing(2),
    },
    formControl: {
        margin: "-13px",
        minWidth: 120,
    },
}));

export default function ControlledOpenSelect(props) {
    const classes = useStyles();
    const [age, setAge] = React.useState('');
    const [open, setOpen] = React.useState(false);

    const handleChange = (event) => {
        setAge(event.target.value);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleOpen = () => {
        setOpen(true);
    };

    return (
        <div className="selectLanguage">
            <FormControl className={classes.formControl}>
                <InputLabel id="demo-controlled-open-select-label">زبان</InputLabel>
                <Select
                    labelId="demo-controlled-open-select-label"
                    id="demo-controlled-open-select"
                    open={open}
                    onClose={handleClose}
                    onOpen={handleOpen}
                    defaultValue={props.language && props.language}
                    value={props.lang}
                    onChange={props.handleLanguage}
                >
                    <MenuItem value={'fa'}>فارسی</MenuItem>
                    <MenuItem value={"en"}>English</MenuItem>
                </Select>
            </FormControl>
        </div>
    );
}


// import React from 'react';
// import { makeStyles } from '@material-ui/core/styles';
// import InputLabel from '@material-ui/core/InputLabel';
// import MenuItem from '@material-ui/core/MenuItem';
// import FormControl from '@material-ui/core/FormControl';
// import Select from '@material-ui/core/Select';
// import Button from '@material-ui/core/Button';

// const useStyles = makeStyles((theme) => ({
//     button: {
//         display: 'block',
//         marginTop: theme.spacing(2),
//     },
//     formControl: {
//         margin: "-13px",
//         minWidth: 120,
//     },
// }));

// export default function ControlledOpenSelect(props) {
//     const classes = useStyles();
//     const [age, setAge] = React.useState('');
//     const [open, setOpen] = React.useState(false);

//     const handleChange = (event) => {
//         setAge(event.target.value);
//     };

//     const handleClose = () => {
//         setOpen(false);
//     };

//     const handleOpen = () => {
//         setOpen(true);
//     };

//     return (
//         <div>
//             <FormControl className={classes.formControl}>
//                 <InputLabel id="demo-controlled-open-select-label">زبان</InputLabel>
//                 <Select
//                     labelId="demo-controlled-open-select-label"
//                     id="demo-controlled-open-select"
//                     open={open}
//                     onClose={handleClose}
//                     onOpen={handleOpen}
//                     value={props.lang}
//                     onChange={props.handleLanguage}
//                 >

//                     <MenuItem value={'fa'}>فارسی</MenuItem>
//                     <MenuItem value={"en"}>English</MenuItem>
//                 </Select>
//             </FormControl>
//         </div>
//     );
// }
